export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const COGNITO_USER_LOGIN = 'COGNITO_USER_LOGIN';
export const COGNITO_USER_LOGIN_FAIL = 'COGNITO_USER_LOGIN_FAIL';
export const COGNITO_USER_LOGIN_SUCCESS = 'COGNITO_USER_LOGIN_SUCCESS';
export const USER_SIGNUP = 'USER_SIGNUP';
export const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const UPDATE_TOKENS = 'UPDATE_TOKENS';
export const CHANGE_ATTRIBUTE = 'CHANGE_ATTRIBUTE';
export const CHANGE_USER_ATTRIBUTE = 'CHANGE_USER_ATTRIBUTE';
export const CHANGE_USER_ATTRIBUTE_SUCCESS = 'CHANGE_USER_ATTRIBUTE_SUCCESS';
export const GET_CURRENT_COGNITO_USER = 'GET_CURRENT_COGNITO_USER';
export const RESETUP_AUTH = 'RESETUP_AUTH';
export const UPDATE_TENANT = 'UPDATE_TENANT';

export const login = (user) => ({
  type: USER_LOGIN,
  user
});

export const loginFail = (error) => ({
  type: USER_LOGIN_FAIL,
  error
});

export const loginSuccess = (user) => ({
  type: USER_LOGIN_SUCCESS,
  user
});

export const cognitoLogin = (user) => ({
  type: COGNITO_USER_LOGIN,
  user
});

export const cognitoLoginFail = (error) => ({
  type: COGNITO_USER_LOGIN_FAIL,
  error
});

export const cognitoLoginSuccess = (user) => ({
  type: COGNITO_USER_LOGIN_SUCCESS,
  user
});

export const logout = () => ({
  type: USER_LOGOUT
});

export const signup = (user) => ({
  type: USER_SIGNUP,
  user
});

export const signupFail = (error) => ({
  type: USER_SIGNUP_FAIL,
  error
});

export const signupSuccess = (user) => ({
  type: USER_SIGNUP_SUCCESS,
  user
});

export const changeAttribute = (params) => ({
  type: CHANGE_ATTRIBUTE,
  params
});

export const updateTokens = (tokens) => ({
  type: UPDATE_TOKENS,
  tokens
});

export const getCurrentCognitoUser = () => ({
  type: GET_CURRENT_COGNITO_USER
});

export const changeUserAttribute = (params) => ({
  type: CHANGE_USER_ATTRIBUTE,
  params
});

export const changeUserAttributeSuccess = (params) => ({
  type: CHANGE_USER_ATTRIBUTE_SUCCESS,
  params
});

export const resetupAuth = () => ({
  type: RESETUP_AUTH
});

export const updateTenant = (tenant) => ({
  type: UPDATE_TENANT,
  tenant
});
